
<template>
  	<Footer/>
</template>

<!-- // // // //  -->

<script>
import Footer from './components/layout.vue'

export default {
  components: {
    Footer
  }
}
</script>





// WEBPACK FOOTER //
// src/containers/app_footer/index.vue